import styles from './ui.module.css';

/**
 * Черта внутри карточки, гаснущая вправо.
 *
 * Не вкуишный Separator: тот рисует сплошную линию во всю ширину и делит
 * карточку на две карточки. Здесь черта только отбивает шапку от содержимого,
 * и в макетах она всегда уходит в ничто — тем же приёмом, что луч у подписи
 * раздела.
 */
export function Divider() {
  return <div className={styles.divider} />;
}
